export default __webpack_public_path__ + "static/media/macfull.f1231137.png";